import request from '@/utils/request';

export type AccountType = 48 | 65 | 25 | 53 | 60;

export interface LoginOrInsert {
  accountType: AccountType; //	必须 账号类型 手机号传48 手机号密码登录传65 谷歌登录：25，苹果登录：53，邮箱登录：60
  accountId: string; //	必须 账号id 手机号
  code?: string; //	非必须 验证码 手机验证时必传
  zoneCode?: string; //	非必须 手机区号
  salt?: string; //  密码登录必须
  newPassword?: string; //  新密码密文，密码登录时必须
  oldPassword?: string; //  旧密码密文，密码登录时必须
  isResult?: false; //	非必须 是否需要返回用户信息
  accessToken?: string; // 谷歌登录
  authCode?: string; //苹果登录
  byAccessToken?: boolean; // 谷歌登录时为true
  fingerprint?: string; // 指纹信息
}

// 登录注册
export const loginOrInsert = async (params: LoginOrInsert) => {
  const res = await request('/api/rest/dlt/user/login', {
    method: 'POST',
    data: params,
  });
  console.log('loginOrInsert', res);
  return res;
};

interface GetPhoneCode {
  phone: string; //	必须 账号id 手机号
}

// 获取验证码
export const getPhoneCode = async (params: GetPhoneCode) => {
  const { phone } = params;
  const res = await request('/api/rest/dlt/user/code/send', {
    method: 'POST',
    data: {
      phone,
      zone: 86,
    },
  });
  return res;
};

// 检查是否已注册
export const checkLogin = async (params: LoginOrInsert) => {
  const res = await request('/api/rest/dlt/user/check', {
    method: 'POST',
    data: params,
  });
  return res;
};

// 获取用户信息
export const getUserInfo = async (accountType: number = 48) => {
  const res = await request('/api/rest/dlt/user/info/get', {
    method: 'POST',
    data: {
      accountType,
    },
  });
  return res;
};

interface UpdateUserInfo {
  accountId: string;
  extendInfo: string;
  nickname: string;
  avatarUrl: string;
}

// 修改用户信息
export const updateUserInfo = async (params: UpdateUserInfo) => {
  const res = await request('/api/rest/dlt/user/info/update', {
    method: 'POST',
    data: params,
  });
  return res;
};

export interface UpdatePasswordType {
  accountId: string;
  salt: string;
  newPassword: string;
  code?: string;
}

// 校验新旧密码
// 10103010  新密码与旧密码相同
// 10103013 旧密码错误
// 10103020 新密码与旧密码相同
export const checkNewOldPassword = async (params: {
  accountId: string;
  newPassword: string;
  oldPassword: string;
  salt: string;
}) => {
  const res = await request('/api/rest/dlt/user/v2/password/reset', {
    method: 'POST',
    data: params,
  });
  return res;
};

// 密码修改
export const updatePassword = async (params: UpdatePasswordType) => {
  const res = await request('/api/rest/dlt/user/password/reset', {
    method: 'POST',
    data: params,
  });
  return res;
};

// 用户权益查询
export const userRights = async () => {
  const res = await request('/api/rest/dlt/user/right/get', {
    method: 'POST',
  });
  return res;
};

// 购买订单记录
export const getOrderRecord = async (params: { pageNum: number; pageSize: number }) => {
  const res = await request('/api/rest/dlt/user/order/get', {
    method: 'POST',
    data: params,
  });
  return res;
};

export interface cancelUserType {
  accountType: number;
  accountId: string;
  deadline: number;
}

// 用户注销
export const cancelUser = async (params: cancelUserType) => {
  const res = await request('/api/rest/dlt/user/cancel', {
    method: 'POST',
    data: params,
  });
  return res;
};

// 验证链注册登录
export const verifyLink = async (encryptCode: string) => {
  const res = await request('/api/rest/dlt/user/link/login', {
    method: 'POST',
    data: {
      encrypt: encryptCode,
    },
  });
  return res;
};

export const getEmailCode = async (email: string) => {
  const res = await request('/api/rest/dlt/user/mail/code/send', {
    method: 'POST',
    data: {
      toAddress: email,
    },
  });
  return res;
};

export const emailLogin = async (params: {
  fingerprint?: string;
  accountId: string;
  code: string;
}) => {
  const res = await request('/api/rest/dlt/user/login', {
    method: 'POST',
    data: {
      accountType: 60,
      ...params,
    },
  });
  return res;
};

// 取消账户注销
export const cancelAccountDeletion = async (params: {
  accountId: string;
  accountType: number;
}) => {
  const res = await request('/api/rest/dlt/user/cancel/giveUp', {
    method: 'POST',
    data: params,
  });
  return res;
};
